<template>
  <div>
    <div class="el-div-data">
      <div style="display: inline;width: 100%">
        <el-input  placeholder="搜索应用" @keydown.enter.native='searchName'
                   v-model="input" ref="mark"
                   class="el-input-search">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class="block" style="float: right;margin-right: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="page.pageSize"
            :current-page="page.pageNum"
            layout="prev, pager, next, jumper"
            :total="page.total">
          </el-pagination>
        </div>
      </div>
      <div>
         <vxe-table border="inner" style="height: 100%;font-size: 16px" :data="tableData"  align="center"
                    :row-style="{height:'20px'}"  :cell-style="{padding:'6px'}"  highlight-hover-row>
          <vxe-table-column  field="id" width="120" title="id"></vxe-table-column>
          <vxe-table-column  title="logo">
            <template width="90" slot-scope="scope" prop="logo">
              <img :src="scope.row.logo" class="vxe-image"/>
            </template>
          </vxe-table-column>
          <vxe-table-column field="name"  width="200" title="名称"></vxe-table-column>
          <vxe-table-column field="version" title="版本"></vxe-table-column>
          <vxe-table-column field="buildTime" title="更新时间"></vxe-table-column>
          <vxe-table-column field="url" width="200" title="链接">
            <template width="90"  slot-scope="scope" prop="url" >
              <el-link :underline="false"  @click="linkDownload(scope.row.url)">{{scope.row.url}}</el-link>
            </template>
          </vxe-table-column>
           <vxe-table-column  field="code" title="二维码">
             <template width="90" slot-scope="scope" prop="logo">
               <el-image :src="scope.row.code" class="vxe-image"   :preview-src-list="imageList" v-popover:popover/>
             </template>
           </vxe-table-column>
          <vxe-table-column field="fixed">
            <template width="90"  slot-scope="scope" prop="fixeId" >
              <div >
                <el-link :underline="false" @click="fixedSelect(scope.row.id,scope.row.index)">
                  <i :class="scope.row.fixedId===1 ? 'el-icon-star-on' : 'el-icon-star-off'" style="
                  display:inline-block; margin:0 auto;font-size: 20px"/>
                </el-link>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="update" >
            <template width="90"  slot-scope="scope" >
             <el-link :underline="false" class="el-link-size" @click.native="jumpCenter(scope.row.id)">查看<i class="el-icon-view el-icon-right"></i> </el-link>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainWorkspace',
  data () {
    return {
      input: '',
      imageList: [],
      tableData: [{
        index: 0,
        id: 0,
        logo: '',
        name: '',
        version: '',
        buildTime: '',
        url: '',
        fixedId: 0,
        code: ''
      }],
      page: {
        pageSize: 8, // 当前页个数
        pageNum: 1, // 当前页数
        total: 0 // 总个数
      }
    }
  },
  activated () {
    this.$refs['mark'].focus()
    this.getDataList()
  },
  methods: {
    getDataList () {
      this.$axios({
        url: this.$global.baseURL.concat('main/fixedSearchByName?pageNum=').concat(this.page.pageNum).concat('&pageSize=').concat(this.page.pageSize).concat('&name=').concat(this.input),
        method: 'get'
      }).then(successResponse => {
        // console.log(successResponse.data.data)
        if (successResponse.data.code === 200) {
          // 重新刷新数据
          let tmpItems = []
          let tmpLogo = ''
          let tmpName = ''
          let tmpVersion = ''
          let tmpBuildTime = ''
          let tmpUrl = ''
          let tmpFixedId = 0
          let tmpCode = ''
          let list = successResponse.data.data.list
          this.imageList = []
          for (let i = 0; i < list.length; i++) {
            tmpLogo = this.$global.baseURL.concat(list[i].image)
            tmpName = list[i].name
            tmpVersion = ''
            tmpBuildTime = list[i].time
            tmpUrl = list[i].url
            tmpFixedId = list[i].fixedId
            tmpCode = this.$global.baseURL.concat(list[i].code)
            this.imageList.push(tmpCode)
            tmpItems.push({index: i,
              id: list[i].id,
              logo: tmpLogo,
              name: tmpName,
              version: tmpVersion,
              buildTime: tmpBuildTime,
              url: tmpUrl,
              fixedId: tmpFixedId,
              code: tmpCode})
          }
          this.page.pageSize = successResponse.data.data.pageSize
          this.page.pageNum = successResponse.data.data.pageNum
          this.page.total = successResponse.data.data.total
          this.tableData = tmpItems
          this.$forceUpdate()
        } else {
        }
      })
    },
    searchName () {
      this.page.pageNum = 1
      this.getDataList()
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.page.pageNum = val
      this.getDataList()
    },
    linkDownload (url) {
      window.open(url, '_blank') // 新窗口打开外链接
    },
    jumpCenter (id) {
      // console.log('jumpCenter', id)
      this.bus.$emit('busChangeHead', '3', id)
      this.$nextTick(function () {
        this.bus.$emit('busChangeAppCenter', id)
      })
    },
    fixedSelect (id, index) {
      // console.log('fixedSelect index', id, index)
      // console.log('fixedSelect', this.tableData[index].id)
      let fixedId = this.tableData[index].fixedId
      let tmpUrl
      if (fixedId === 1) {
        tmpUrl = this.$global.baseURL.concat('main/fixedDelete?informationId=').concat(id)
      } else {
        tmpUrl = this.$global.baseURL.concat('main/fixedAdd?informationId=').concat(id)
      }
      this.$axios({
        url: tmpUrl,
        method: 'get'
      }).then(successResponse => {
        // console.log(successResponse.data.data)
        if (successResponse.data.code === 200) {
          this.bus.$emit('busUpdateLeft')
          this.tableData[index].fixedId = Math.abs(1 - fixedId)
          this.$forceUpdate()
        } else {
          this.errorInfo = true
          this.errInfo = '网络出了问题，请重试'
          this.$message.error('网络出了问题，请重试')
        }
      })
    }
  }
}
</script>

<style scoped>
.vxe-table-column{
  font-size: large;
}
.vxe-image-bigger{
  width: 200px;
  height: 200px;
  border: none;
}
.vxe-image{
  width: 60px;
  height: 60px;
  border: none;
}
.el-div-data{
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
.el-row {
}
.el-col {
  border-radius: 4px;

}
.bg-purple-dark {
}
.bg-purple {
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  line-height: 30px;
}
.grid-span{
  font-size: 22px;
  color: crimson;
  padding: 20px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.div-data-head{
  width: 100%;
  height: 80px;
  display:inline;
  margin-bottom: 40px;
}
.el-input-search{
  width: 20%;
  min-width: 400px;
  margin-right: 40px;
  margin-bottom: 20px;
}
.el-link-size{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/MainWorkspace.vue